var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEnterMsg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 22C0 9.84974 9.84974 0 22 0C34.1503 0 44 9.84974 44 22C44 34.1503 34.1503 44 22 44C9.84974 44 0 34.1503 0 22Z",
    fill: "url(#paint0_linear_2182_24743)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7193 23.67C30.7066 23.2023 30.7066 21.7973 29.7192 21.3296L17.9573 15.7582C16.7864 15.2036 15.6169 16.5219 16.3073 17.6183L19.0083 21.8844L22.7731 21.8286C23.1545 21.8229 23.4682 22.1275 23.4738 22.5088C23.4795 22.8902 23.1749 23.2039 22.7935 23.2096L18.9121 23.2671L16.3072 27.3813C15.6169 28.4777 16.7864 29.7961 17.9573 29.2415L29.7193 23.67Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2182_24743",
    x1: 22,
    y1: 0,
    x2: 22,
    y2: 35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00ABEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007DFE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnterMsg);
export default __webpack_public_path__ + "static/media/enter-msg.d6a7b3234b6c2812947cec1516bc40e5.svg";
export { ForwardRef as ReactComponent };